import { render, staticRenderFns } from "./HeaderV2ControlBtnAtom.vue?vue&type=template&id=b99fef6c&scoped=true&"
import script from "./HeaderV2ControlBtnAtom.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2ControlBtnAtom.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2ControlBtnAtom.vue?vue&type=style&index=0&id=b99fef6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99fef6c",
  null
  
)

export default component.exports